// D10 (spec d10-v01 §3.4/§4.4; contrato-d10): troca de e-mails do ticket na coluna central.
// - Carga: observer childList SEM subtree no #ticket-detail-chat[data-email] de cada detalhe (FE-2). Ao chegar a lista,
//   rola até o fim e liga o "ver mais". Se veio o erro ("Tentar de novo"), arma de novo para a próxima carga.
//   O observer do detalhe anterior é desligado quando o detalhe é trocado.
// - "ver mais/ver menos": clamp de 6 linhas no CSS; o botão só aparece onde o texto foi cortado.
// - Compositor (envia e-mail REAL): fetch POST multipart próprio, sem .form-ajax/#uploadFile/.bt-ajax/.tk-assumir (FE-3).
//   Ctrl/Cmd+Enter envia, Enter quebra linha. Erro: mensagem no compositor, texto e anexo ficam. Sucesso: 3 alvos do
//   servidor; o compositor NÃO é trocado — o próprio formulário é limpo e o botão de emoji (mesmo nó) continua ligado.
// - Arquivo acima de 25 MB é recusado antes de enviar; HTTP 413 (upload acima do limite do servidor) mantém tudo.

// reclame-aqui (d13-v02): a mesma thread serve o ticket do Reclame Aqui (#ticket-detail-chat[data-canal="ra"]): modos
// Pública/Privada (aria-disabled, regras de anexo por modo), "Solicitar avaliação" (Swal.fire com focusCancel — IRREVERSÍVEL),
// pílula "N novas mensagens" e result.selos no incremental. O caminho do e-mail não muda.

const LIMITE_ARQ = 25 * 1024 * 1024;
const SEL_CHAT = '#ticket-detail-chat[data-email], #ticket-detail-chat[data-canal]';
const MSG_RA_VAZIO = 'Escreva a mensagem.';
const MSG_RA_PUBLICA_ANEXO = 'Resposta pública não aceita anexo. Remova o arquivo ou mude para Privada.';
const MSG_RA_TIPO = 'O Reclame Aqui não aceita este tipo de arquivo. Use PNG, JPG, GIF, PDF, DOC, XLS, CSV ou áudio (MP3, WMA, OGG, AAC).';
const MSG_RA_AVAL_REDE = 'Não foi possível solicitar agora. Tente de novo.';
const MSG_VAZIO = 'Escreva a mensagem ou anexe um arquivo.';
const MSG_REDE = 'Não foi possível enviar agora. O texto continua aqui; tente de novo.';
const MSG_GRANDE = 'O arquivo passa de 25 MB.';

const EmailThread = function () {

    let vigia = null;

    // ---------- lista ----------
    const ligarVerMais = (raiz) => {
        raiz.querySelectorAll('.tk-mail-txt').forEach(txt => {
            const btn = txt.nextElementSibling;
            if (!btn || !btn.classList.contains('tk-mail-mais') || txt.hasAttribute('data-aberto')) return;
            btn.hidden = !(txt.scrollHeight > txt.clientHeight + 1);
        });
    };

    const rolarFim = (thread) => {
        const lista = thread.querySelector('.tk-mail-lista');
        if (lista) lista.scrollTop = lista.scrollHeight;
    };

    // D32 (b) (d32-plano §4; D-2: a pílula "N novos" da D12 fica): a altura da LISTA muda depois do rolarFim (painel único reexibido —
    // com o detalhe escondido o scrollTop atribuído se perde —, compositor, janela). Quem estava no fim continua no fim; quem rolou
    // para cima não é puxado. Estado do "no fim" vem do scroll da própria lista (ouvinte de captura no init).
    let roMail = null, mailNoFim = true;
    const ancorarMail = (thread) => {
        if (roMail) { roMail.disconnect(); roMail = null; }
        const lista = thread.querySelector('.tk-mail-lista');
        mailNoFim = true;
        if (!lista || !window.ResizeObserver) return;
        roMail = new ResizeObserver(() => { if (mailNoFim && lista.isConnected) lista.scrollTop = lista.scrollHeight; });
        roMail.observe(lista);
    };

    const aoCarregar = (chat) => {
        const thread = chat.querySelector('.tk-mail');
        if (!thread) return;
        rolarFim(thread);
        ligarVerMais(thread);
        ancorarMail(thread);
    };

    const vigiar = (chat) => {
        if (vigia) vigia.disconnect();
        vigia = new MutationObserver(() => {
            vigia.disconnect();
            vigia = null;
            aoCarregar(chat);
            // erro com "Tentar de novo": a próxima carga troca os filhos de novo → arma outra vez (uso único por carga)
            if (chat.isConnected && chat.querySelector('.tk-mail-lista > .tk-mail-erro')) vigiar(chat);
        });
        vigia.observe(chat, { childList: true });
    };

    const aoTrocarDetalhe = () => {
        if (vigia) { vigia.disconnect(); vigia = null; }
        if (roMail) { roMail.disconnect(); roMail = null; }   // D32 (b): a lista anterior saiu com o detalhe
        novos = 0;   // D12: o aviso de novos é da thread anterior (o nó saiu com ela)
        const chat = document.querySelector(SEL_CHAT);
        if (chat) vigiar(chat);
    };

    const alternarMais = (btn) => {
        const txt = document.getElementById(btn.getAttribute('aria-controls'));
        if (!txt) return;
        const abrir = !txt.hasAttribute('data-aberto');
        if (abrir) txt.setAttribute('data-aberto', ''); else txt.removeAttribute('data-aberto');
        btn.textContent = abrir ? 'ver menos' : 'ver mais';
        btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    };

    // ---------- compositor ----------
    const partes = (form) => ({
        texto: form.querySelector('textarea'),
        arq: form.querySelector('input[type="file"]'),
        info: form.querySelector('.tk-mail-arq'),
        erro: form.querySelector('.tk-mail-erro'),
        enviar: form.querySelector('.tk-mail-enviar'),
    });

    const mostrarErro = (form, msg) => {
        const p = partes(form);
        p.erro.textContent = msg;
        p.erro.hidden = false;
        p.texto.focus();
    };
    const limparErro = (form) => { const p = partes(form); p.erro.textContent = ''; p.erro.hidden = true; };

    const pintarArquivo = (form) => {
        const p = partes(form);
        const f = p.arq.files && p.arq.files[0];
        p.info.textContent = '';
        if (!f) { p.info.hidden = true; return; }
        const nome = document.createElement('span');
        nome.textContent = f.name;
        const tirar = document.createElement('button');
        tirar.type = 'button';
        tirar.className = 'tk-mail-arq-tirar';
        tirar.textContent = 'remover';
        p.info.append(nome, tirar);
        p.info.hidden = false;
    };

    const limparForm = (form) => {
        const p = partes(form);
        p.texto.value = '';
        p.arq.value = '';
        pintarArquivo(form);
        limparErro(form);
        const dica = form.querySelector('.tk-mail-dica');   // RA (o form do e-mail não tem)
        if (dica) { dica.textContent = ''; dica.hidden = true; }
    };

    // ---------- RA: regras de anexo, modos, aria-disabled, avaliação ----------
    const ehRaForm = (form) => form.dataset.canal === 'ra';
    const listaCsv = (v) => (v || '').split(',').map(x => x.trim().toLowerCase()).filter(Boolean);
    // Mensagem do limite do arquivo, ou null. Sem os data-arq-* (form do e-mail): a regra de hoje (25 MB).
    const problemaArquivo = (form, f) => {
        if (!f) return null;
        if (!ehRaForm(form)) return f.size > LIMITE_ARQ ? MSG_GRANDE : null;
        const ext = (f.name.split('.').pop() || '').toLowerCase();
        const tipos = listaCsv(form.dataset.arqTipos);
        const audio = listaCsv(form.dataset.arqTiposAudio);
        if (tipos.length && tipos.indexOf(ext) < 0) return MSG_RA_TIPO;
        const ehAudio = audio.indexOf(ext) >= 0;
        const max = parseInt(ehAudio ? form.dataset.arqMaxAudio : form.dataset.arqMax, 10) || 0;
        if (max && f.size > max) return (ehAudio ? 'O áudio passa de ' : 'O arquivo passa de ') + Math.round(max / 1048576) + ' MB.';
        return null;
    };

    const peDe = (el) => el.closest('.tk-mail-pe');
    const dicaEm = (el, msg) => {
        const pe = peDe(el);
        const d = pe ? pe.querySelector('.tk-mail-dica') : null;
        if (!d) return;
        d.textContent = msg || '';
        d.hidden = !msg;
    };
    const erroEm = (el, msg) => {
        const pe = peDe(el);
        const e = pe ? pe.querySelector('.tk-mail-erro') : null;
        if (!e) return;
        e.textContent = msg || '';
        e.hidden = !msg;
    };

    const trocarModo = (chip) => {
        const form = chip.closest('.tk-mail-form');
        if (!form) return;
        const modo = chip.dataset.modo === 'privada' ? 'privada' : 'publica';
        const nome = form.dataset.nome || 'o cliente';
        const p = partes(form);
        form.querySelectorAll('.tk-mail-modo').forEach(c => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
        form.dataset.modo = modo;
        const campo = form.querySelector('input[name="modo"]');
        if (campo) campo.value = modo;
        const rot = 'Responder a ' + nome + ' no Reclame Aqui (' + (modo === 'privada' ? 'privada' : 'pública') + ')';
        p.texto.setAttribute('placeholder', rot);
        p.texto.setAttribute('aria-label', rot);
        p.enviar.setAttribute('aria-label', (modo === 'privada' ? 'Enviar mensagem privada para ' : 'Enviar resposta pública para ') + nome);
        const para = form.querySelector('.tk-mail-para');
        if (para) para.textContent = modo === 'privada' ? para.dataset.privada : para.dataset.publica;
        const label = form.querySelector('label.tk-mail-ico');
        if (modo === 'privada') {
            p.arq.disabled = false;
            if (label) { label.removeAttribute('aria-disabled'); label.setAttribute('title', 'Anexar arquivo'); }
        } else {
            p.arq.disabled = true;   // o arquivo escolhido NÃO é apagado (só deixa de ir no FormData); a guarda avisa
            if (label) { label.setAttribute('aria-disabled', 'true'); label.setAttribute('title', 'Anexo só em mensagem privada'); }
        }
        dicaEm(form, '');
    };

    const atualizarAvaliar = (btn, av) => {
        if (!btn || !av) return;
        if (av.mostrar === false) { btn.remove(); return; }
        if (av.pode === false) {
            btn.setAttribute('aria-disabled', 'true');
            btn.dataset.motivo = av.motivo || '';
            btn.setAttribute('title', av.motivo || '');
        } else {
            btn.removeAttribute('aria-disabled');
            delete btn.dataset.motivo;
            btn.removeAttribute('title');
        }
    };

    const solicitarAvaliacao = (btn) => {
        const thread = btn.closest('.tk-mail');
        const nome = btn.dataset.nome || 'o cliente';
        const pub = btn.dataset.publicId || '';
        erroEm(btn, '');
        dicaEm(btn, '');
        if (!window.Swal || typeof window.Swal.fire !== 'function') { erroEm(btn, MSG_RA_AVAL_REDE); return; }   // sem confirmação, não pede
        window.Swal.fire({
            title: 'Solicitar avaliação a ' + nome + '?',
            text: 'O Reclame Aqui vai enviar 1 e-mail a ' + nome + ' pedindo a nota '
                + (pub ? 'da reclamação RA #' + pub : 'desta reclamação')
                + '. Só é possível pedir uma vez, e o pedido não pode ser desfeito.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Solicitar avaliação',
            cancelButtonText: 'Cancelar',
            focusCancel: true,   // Enter não confirma por engano
        }).then(r => {
            if (!r || !r.isConfirmed) return;   // cancelar: nada acontece (o Swal devolve o foco ao botão)
            const dados = new FormData();
            dados.set('user_id', btn.dataset.userId || '0');
            dados.set('novo_n', String(thread ? proximoN(thread) : 1));
            const L = window.Loader;
            if (L) L.show();
            btn.setAttribute('aria-busy', 'true');
            btn.setAttribute('aria-disabled', 'true');
            btn.textContent = 'Solicitando…';
            let ok = false;
            fetch(btn.dataset.url, {
                method: 'POST', body: dados, credentials: 'same-origin',
                headers: { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            }).then(resp => {
                if (!resp.ok) throw new Error(MSG_RA_AVAL_REDE);
                return resp.json().catch(() => { throw new Error(MSG_RA_AVAL_REDE); });
            }).then(d => {
                if (!d || d.error) throw new Error((d && d.message) || MSG_RA_AVAL_REDE);   // 4090–4097: texto do servidor
                ok = true;
                const res = d.result || {};
                if (thread && res.elements && res.elements.length) {
                    aplicar(res.elements, thread);
                    ligarVerMais(thread);
                    rolarFim(thread);
                }
                atualizarAvaliar(btn, res.avaliacao);
                if (d.message) dicaEm(btn, d.message);   // parcial: aceito pelo RA, registro na próxima sincronização
            }).catch(err => {
                erroEm(btn, err && err.message ? err.message : MSG_RA_AVAL_REDE);
            }).finally(() => {
                if (L) L.hide();
                btn.removeAttribute('aria-busy');
                btn.textContent = 'Solicitar avaliação';
                if (!ok) { btn.removeAttribute('aria-disabled'); }   // erro: volta ao estado anterior (estava disponível)
            });
        });
    };

    const proximoN = (thread) => {
        const ph = thread.querySelectorAll('.tk-mail-novo');
        const ult = ph.length ? ph[ph.length - 1] : null;
        const m = ult ? /-(\d+)$/.exec(ult.id) : null;
        return m ? parseInt(m[1], 10) : 1;
    };

    const csrf = () => {
        const m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : (typeof CSRF_TOKEN !== 'undefined' ? CSRF_TOKEN : '');
    };

    // D12 R-3: a mesma mensagem pode chegar pelo evento (incremental) e pela resposta do envio, em qualquer ordem.
    // Fica a PRIMEIRA ocorrência de cada #tk-mail-c{id}; a repetida sai, com o separador de dia que veio só com ela.
    const tirarRepetidas = (thread) => {
        const vistos = new Set();
        thread.querySelectorAll('.tk-mail-msg[id]').forEach(el => {
            if (!vistos.has(el.id)) { vistos.add(el.id); return; }
            const antes = el.previousElementSibling;
            el.remove();
            if (antes && antes.classList.contains('tk-mail-dia')
                && !(antes.nextElementSibling && antes.nextElementSibling.classList.contains('tk-mail-msg'))) antes.remove();
        });
    };

    const aplicar = (elements, thread) => {
        (elements || []).forEach(el => {
            if (!el || typeof el.target !== 'string') return;
            document.querySelectorAll(el.target).forEach(alvo => { alvo.innerHTML = el.html || ''; });
        });
        tirarRepetidas(thread);
        const vazio = thread.querySelector('.tk-mail-vazio');
        if (vazio && thread.querySelector('.tk-mail-msg')) vazio.remove();
    };

    const enviar = (form) => {
        const p = partes(form);
        const thread = form.closest('.tk-mail');
        if (!thread || p.enviar.disabled) return;
        limparErro(form);
        const f = p.arq.files && p.arq.files[0];
        if (ehRaForm(form)) {
            // guardas locais do RA (mesmos textos do servidor): sem requisição; texto e arquivo ficam
            if (p.texto.value.trim() === '') { mostrarErro(form, MSG_RA_VAZIO); return; }
            if (f && form.dataset.modo !== 'privada') { mostrarErro(form, MSG_RA_PUBLICA_ANEXO); return; }
            const prob = problemaArquivo(form, f);
            if (prob) { mostrarErro(form, prob); return; }
        } else {
            if (p.texto.value.trim() === '' && !f) { mostrarErro(form, MSG_VAZIO); return; }
            if (f && f.size > LIMITE_ARQ) { mostrarErro(form, MSG_GRANDE); return; }
        }

        const dados = new FormData(form);
        dados.set('novo_n', String(proximoN(thread)));
        const L = window.Loader;
        if (L) L.show();
        p.enviar.disabled = true;

        fetch(form.dataset.acao, {
            method: 'POST', body: dados, credentials: 'same-origin',
            headers: { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        }).then(r => {
            if (r.status === 413) throw new Error(MSG_GRANDE);   // acima do limite do servidor: nada se perde
            if (!r.ok) throw new Error(MSG_REDE);
            return r.json().catch(() => { throw new Error(MSG_REDE); });
        }).then(d => {
            if (!d || d.error) { mostrarErro(form, (d && d.message) || MSG_REDE); return; }   // texto e anexo ficam
            const els = d.result && d.result.elements;
            if (els && els.length) {
                aplicar(els, thread);
                limparForm(form);   // o modo (RA) é mantido
                ligarVerMais(thread);
                rolarFim(thread);
                p.texto.focus();
                if (d.message) mostrarErro(form, d.message);   // RA X3: anexo enviado, cópia local não guardada (o e-mail não manda message aqui)
            } else {
                // enviado, mas a releitura falhou: o servidor manda só o aviso; o formulário é limpo
                limparForm(form);
                if (d.message) mostrarErro(form, d.message);
            }
        }).catch(err => {
            mostrarErro(form, err && err.message ? err.message : MSG_REDE);
        }).finally(() => {
            if (L) L.hide();
            p.enviar.disabled = false;
        });
    };

    // ---------- D12: tempo real (Pusher) ----------
    // Um handler GLOBAL do LiaTicketEvent no canal lia.{CLIENT_NAME}; a cada evento ele consulta qual thread está aberta.
    // LICOES 17: registrar depois do Lia.init(); nunca Echo.leave nem stopListening sem o próprio handler; re-assinar no
    // pageshow do bfcache. Eventos do ticket aberto agrupados (1 s) → GET incremental ?depois_de={último id} → anexa ao fim
    // (antes do placeholder da D10), pulando ids já na tela. O compositor NUNCA é tocado. Erro: silencioso.
    const LOTE_MAIL_MS = 1000;
    let canalMail = null;
    let loteTimer = null;
    let loteEspera = [];
    let buscando = false;
    let refazer = false;   // R-2: evento durante a chamada → UMA nova chamada ao fim desta
    let novos = 0;

    const threadAberta = () => document.querySelector('#ticket-detail-chat[data-email] .tk-mail[data-ticket], #ticket-detail-chat[data-canal] .tk-mail[data-ticket]');
    const ultimoExibido = (thread) => {
        if (thread.dataset.ultimo) return parseInt(thread.dataset.ultimo, 10) || 0;
        const msgs = thread.querySelectorAll('.tk-mail-msg[id^="tk-mail-c"]');
        const ult = msgs.length ? msgs[msgs.length - 1] : null;
        return ult ? parseInt(ult.id.replace('tk-mail-c', ''), 10) || 0 : 0;
    };
    const noFim = (lista) => lista.scrollHeight - lista.scrollTop - lista.clientHeight <= 8;

    // Aviso "N novos e-mails": a pílula da fila (D04, .tk-novos) presa no RODAPÉ da lista; criada só quando precisa.
    const esconderNovos = (thread) => {
        novos = 0;
        const w = thread ? thread.querySelector('.tk-mail-novos') : document.querySelector('.tk-mail-novos');
        if (w) w.remove();
    };
    const mostrarNovos = (thread, n) => {
        novos += n;
        const lista = thread.querySelector('.tk-mail-lista');
        let w = lista.querySelector('.tk-mail-novos');
        if (!w) {
            w = document.createElement('div');
            w.className = 'tk-novos-wrap tk-mail-novos';
            w.innerHTML = '<button type="button" class="tk-novos"><span class="tk-novos-txt"></span><i class="ai ai-arrow-down" aria-hidden="true"></i></button>';
            lista.append(w);
        }
        const b = w.querySelector('.tk-novos');
        // d12-v01 A3: "1 novo e-mail" / "N novos e-mails" / "99+ novos e-mails"; RA (d13 §5.2): "… nova(s) mensagem(ns)"
        const rot = novos > 99 ? '99+' : String(novos);
        if (thread.dataset.canal === 'ra') {
            b.querySelector('.tk-novos-txt').textContent = novos === 1 ? '1 nova mensagem' : rot + ' novas mensagens';
            b.setAttribute('aria-label', (novos === 1 ? '1 mensagem nova' : rot + ' mensagens novas') + ' no fim da conversa. Ir para o fim.');
            return;
        }
        b.querySelector('.tk-novos-txt').textContent = novos === 1 ? '1 novo e-mail' : rot + ' novos e-mails';
        b.setAttribute('aria-label', (novos === 1 ? '1 e-mail novo' : rot + ' e-mails novos') + ' no fim da conversa. Ir para o fim.');
    };

    const aplicarNovas = (thread, r) => {
        const lista = thread.querySelector('.tk-mail-lista');
        const ph = Array.from(thread.querySelectorAll('.tk-mail-novo')).filter(p => !p.firstElementChild).pop();
        if (!lista || !ph) return 0;
        const estavaNoFim = noFim(lista);
        let n = 0;
        (r.mensagens || []).forEach(m => {
            if (!m || document.getElementById('tk-mail-c' + m.id)) return;   // já na tela (ex.: a resposta da D10)
            ph.insertAdjacentHTML('beforebegin', m.html || '');
            n++;
        });
        if (r.ultimo_id) thread.dataset.ultimo = String(r.ultimo_id);
        if (!n) return 0;
        const vazio = thread.querySelector('.tk-mail-vazio');
        if (vazio) vazio.remove();
        ligarVerMais(thread);
        if (estavaNoFim) rolarFim(thread); else mostrarNovos(thread, n);   // rolado para cima: a leitura não se mexe
        return n;
    };

    const buscarNovas = () => {
        loteTimer = null;
        if (buscando) { refazer = true; return; }   // R-2: uma chamada incremental por vez (a espera fica para a próxima)
        const espera = loteEspera;
        loteEspera = [];
        const thread = threadAberta();
        const chat = thread ? thread.closest('#ticket-detail-chat') : null;
        if (!thread || !chat || !chat.dataset.ajax || !thread.querySelector('.tk-mail-lista')) { espera.forEach(p => p.resolve(0)); return; }
        const tid = thread.dataset.ticket;
        let url;
        try { url = new URL(chat.dataset.ajax, location.href); } catch (e) { espera.forEach(p => p.resolve(0)); return; }
        url.searchParams.set('depois_de', String(ultimoExibido(thread)));
        buscando = true;
        // R-F1: teto de 20 s. Abortou → cai no catch: sai de "buscando", depois_de não avança, o próximo evento tenta de novo.
        const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const teto = ctrl ? setTimeout(() => ctrl.abort(), 20000) : null;
        fetch(url.toString(), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
            .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(d => {
                if (!d || d.error || !d.result) throw new Error('erro');
                const atual = threadAberta();
                if (!atual || atual.dataset.ticket !== tid) return 0;   // outro ticket abriu no meio: descarta
                // RA (I-13): selos da faixa em tempo real; o seletor só casa se a faixa aberta for deste ticket
                if (typeof d.result.selos === 'string') {
                    document.querySelectorAll('.tk-faixa[data-ticket="' + tid + '"] .tk-faixa-selos').forEach(el => { el.innerHTML = d.result.selos; });
                }
                return aplicarNovas(atual, d.result);
            })
            .then(n => espera.forEach(p => p.resolve(n)))
            .catch(e => espera.forEach(p => p.reject(e)))   // silencioso na tela; tenta no próximo evento
            .finally(() => {
                clearTimeout(teto);
                buscando = false;
                if (refazer) { refazer = false; buscarNovas(); }   // R-2: refaz UMA vez com o depois_de atualizado
            });
    };

    // Mesmo caminho para o Echo e para o gancho de teste (window.tkMail).
    const receberEvento = (payload) => new Promise((resolve, reject) => {
        const thread = threadAberta();
        const t = payload ? parseInt(payload.ticket_id, 10) : 0;
        if (!thread || !t || String(t) !== thread.dataset.ticket) { resolve(0); return; }
        loteEspera.push({ resolve, reject });
        if (!loteTimer) loteTimer = setTimeout(buscarNovas, LOTE_MAIL_MS);
    });

    const aoTicketMail = (e) => { receberEvento(e).catch(() => {}); };
    const assinarMail = () => {
        if (typeof window.Echo === 'undefined' || typeof client_name === 'undefined' || !client_name) return;
        try {
            if (canalMail) canalMail.stopListening('LiaTicketEvent', aoTicketMail);   // só o próprio handler
            canalMail = window.Echo.private('lia.' + client_name);
            canalMail.listen('LiaTicketEvent', aoTicketMail);
        } catch (err) { canalMail = null; }   // sem Pusher (local): sem tempo real, sem mensagem
    };

    return {
        init: function () {
            const detalhe = document.querySelector('.open-ticket-detail');
            if (!detalhe) return;   // só na tela de tickets nova
            new MutationObserver(aoTrocarDetalhe).observe(detalhe, { childList: true });

            document.addEventListener('click', (e) => {
                const t = e.target instanceof Element ? e.target : null;
                if (!t) return;
                // RA: controle indisponível (aria-disabled continua alcançável): mostra o motivo e não executa a ação
                const indisp = t.closest('.tk-mail-pe [aria-disabled="true"]');
                if (indisp) {
                    e.preventDefault();
                    if (!indisp.hasAttribute('aria-busy')) dicaEm(indisp, indisp.dataset.motivo || indisp.getAttribute('title') || '');
                    return;
                }
                const modo = t.closest('.tk-mail-form .tk-mail-modo');
                if (modo) { trocarModo(modo); return; }
                const aval = t.closest('.tk-mail-pe .tk-mail-avaliar');
                if (aval) { solicitarAvaliacao(aval); return; }
                const mais = t.closest('.tk-mail .tk-mail-mais');
                if (mais) { alternarMais(mais); return; }
                const tirar = t.closest('.tk-mail-form .tk-mail-arq-tirar');
                if (tirar) {
                    const form = tirar.closest('.tk-mail-form');
                    partes(form).arq.value = '';
                    pintarArquivo(form);
                }
            });
            document.addEventListener('change', (e) => {
                const inp = e.target instanceof Element ? e.target.closest('.tk-mail-form input[type="file"]') : null;
                if (!inp) return;
                const form = inp.closest('.tk-mail-form');
                limparErro(form);
                pintarArquivo(form);
                const prob = problemaArquivo(form, inp.files && inp.files[0]);   // e-mail: 25 MB como antes; RA: tipo/3 MB/7 MB
                if (prob) mostrarErro(form, prob);
            });
            document.addEventListener('submit', (e) => {
                const form = e.target instanceof Element ? e.target.closest('.tk-mail-form') : null;
                if (!form) return;
                e.preventDefault();
                enviar(form);
            });
            document.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter' || !(e.ctrlKey || e.metaKey)) return;   // Enter sozinho quebra linha
                const form = e.target instanceof Element ? e.target.closest('.tk-mail-form') : null;
                if (!form || e.target.tagName !== 'TEXTAREA') return;
                e.preventDefault();
                enviar(form);
            });

            // D12: pílula "N novos e-mails" leva ao fim; chegar ao fim rolando também a esconde.
            document.addEventListener('click', (e) => {
                const b = e.target instanceof Element ? e.target.closest('.tk-mail-novos .tk-novos') : null;
                if (!b) return;
                const thread = b.closest('.tk-mail');
                const lista = thread.querySelector('.tk-mail-lista');
                const reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                lista.scrollTo({ top: lista.scrollHeight, behavior: reduz ? 'auto' : 'smooth' });
                esconderNovos(thread);
                lista.focus({ preventScroll: true });   // d12-v01 A4: o foco não fica no botão que sumiu, sem rolar de novo
            });
            document.addEventListener('scroll', (e) => {
                const lista = e.target instanceof Element && e.target.classList.contains('tk-mail-lista') ? e.target : null;
                if (lista) mailNoFim = noFim(lista);   // D32 (b)
                if (lista && novos && noFim(lista)) esconderNovos(lista.closest('.tk-mail'));
            }, { capture: true, passive: true });

            // Depois do Lia.init() (app.js, $(document).ready registrado antes): o cleanup dele apagaria o handler.
            setTimeout(assinarMail, 0);
            // bfcache: o pagehide do Lia.js deixou o canal → re-assina e busca o que chegou enquanto a página estava guardada
            window.addEventListener('pageshow', (e) => {
                if (!e.persisted) return;
                assinarMail();
                const t = threadAberta();
                if (t) receberEvento({ ticket_id: t.dataset.ticket }).catch(() => {});
            });

            window.tkMail = {
                receberEvento: receberEvento,
                estado: () => {
                    const t = threadAberta();
                    return { ticket: t ? parseInt(t.dataset.ticket, 10) : null, ultimo: t ? ultimoExibido(t) : null, novos: novos, buscando: buscando };
                },
            };
        },
    };
}();

module.exports = EmailThread;
